import _isEmpty from "lodash-es/isEmpty";
import _get from "lodash-es/get";

/**
 * Decides whether a Singapore account must complete the MyInfo / collected
 * account onboarding before it can make a payment.
 *
 * This mirrors the gating the "Make payment" button runs in
 * `MainLayout/components/ButtonsHeading` (`onChoosePaymentType`), so both the
 * button and the route guard (`withRequireOnboarding`) behave identically.
 *
 * @returns `null` when the user may proceed straight to payment creation, or
 * `{ isBusiness }` when the user must be sent through MyInfo first (the flag
 * tells MyInfo whether to run the business or personal path).
 */
export const checkIsBusinessMyInfo = (
  collectedAccount: any,
  isPersonalAccount: boolean
): { isBusiness: boolean } | null => {
  const isCollectedAccount = !_isEmpty(collectedAccount);
  const isDraftCollectedAccount = isCollectedAccount && collectedAccount.draft;
  const hasBizfile =
    isCollectedAccount &&
    !_isEmpty(
      _get(collectedAccount, "payeeData.kycDocuments.b_acra_bizfile", [])
    );
  const hasMyinfoBiz =
    isCollectedAccount &&
    !_isEmpty(_get(collectedAccount, "payeeData.myinfoBiz", null));

  if (!isCollectedAccount) {
    return { isBusiness: !isPersonalAccount };
  }

  if (isDraftCollectedAccount) {
    if (hasMyinfoBiz) {
      return null;
    }
    if (hasBizfile && !hasMyinfoBiz) {
      return { isBusiness: false };
    }
    return { isBusiness: !isPersonalAccount };
  }

  return null;
};
